import { ProductMediaEntity } from '@schemas/product-media-entity.interface';

export interface SearchResponse {
  total: number;
  hits: Hit[];
}

export interface AdminSearchResponse {
  totalrow: number;
  productlist: AdminProduct[];
}

export interface AdminProduct {
  id: string;
  base_currency: string;
  commission_user_id: number;
  commission_user_type: string;
  cost_of_good: string;
  created_at: string;
  deleted: string | null;
  discount_price: string;
  item_location_id: number;
  motherpage_seo_url: null;
  name: string;
  regular_price: string;
  sku: string;
  status: string;
  stock: number;
  brand: {
    name: string;
  };
  categories: AdminProductCategory[];
  discovers: any[];
  item_location: any;
  media_entities: ProductMediaEntity;
  physical_store: string;
  physical_store_barcode: string;
  destinations: string[];
  product_barcode: string;
  seo_url: string;
  gender: string;
  seller_sku?: string;
  is_discount?: number;
  rejection_reason?: string;
  rejection_reason_other?: string;
}

export interface AdminProductCategory {
  id: number;
  name: string;
  language: string;
}

export interface Hit {
  id: string;
  name: string;
  brandName: string;
  stylesSeoUrl: string;
  brandsSeoUrl: string;
  regularPriceUSD: number;
  regularPriceEUR: number;
  regularPriceGBP: number;
  regularPriceDKK: number;
  regularPriceSEK: number;
  regularPriceNOK: number;
  regularPricePLN: number;
  regularPriceJPY: number;
  discountedPriceUSD: number;
  discountedPriceEUR: number;
  discountedPriceGBP: number;
  discountedPriceDKK: number;
  discountedPriceSEK: number;
  discountedPriceNOK: number;
  discountedPricePLN: number;
  discountedPriceJPY: number;
  bagsSize: string;
  clothingSize: string;
  shoesSize: string;
  stock: number;
  imageUrl: string;
  originalUrl?: string;
  totalWishlisted: number;
  commissionUserId: number;
  commissionUserType: CommissionUserType | string;
  isDiscount: number;
  discount: number;
  fixedDiscount: number;
  discountPercentage: number;
  sku: string;
  sellerSku: string;
  category: string;
  sub: string;
  color: string;
  objectId: string;
  conditionRating: string;
  position?: number;
  discover?: string[];
  recommend?: boolean;
  nameEn?: string;
  colorEn?: string;
  stylesSeoUrlEn?: string;
  brandsSeoUrlEn?: string;
  categoryEn?: string;
  subEn?: string;
  physicalStorePrice?: string;
  mediaEntities?: StoreMediaEntity[];
  campaignId?: string;
}

export interface StoreHit {
  id: string;
  name: string;
  description: string;
  brandName: string;
  stylesSeoUrl: string;
  brandsSeoUrl: string;
  regularPriceUSD: number;
  regularPriceEUR: number;
  regularPriceGBP: number;
  regularPriceDKK: number;
  regularPriceSEK: number;
  regularPriceNOK: number;
  regularPricePLN: number;
  regularPriceJPY: number;
  discountedPriceUSD: number;
  discountedPriceEUR: number;
  discountedPriceGBP: number;
  discountedPriceDKK: number;
  discountedPriceSEK: number;
  discountedPriceNOK: number;
  discountedPricePLN: number;
  discountedPriceJPY: number;
  bagsSize: string;
  clothingSize: string;
  shoesSize: string;
  stock: number;
  imageUrl: string;
  totalWishlisted: number;
  commissionUserId: number;
  commissionUserType: string;
  isDiscount: number;
  discount: number;
  fixedDiscount: number;
  discountPercentage: number;
  sku: string;
  sellerSku: string;
  category: string;
  sub: string;
  color: string;
  objectId: string;
  conditionRating: number;
  position: number;
  discover: string;
  mediaEntities: StoreMediaEntity[];
  material?: string;
  measurement?: string;
  size?: string;
  heelHeight?: string;
  shaftHeight?: string;
  chainLength?: string;
  pandantMeasurement?: string;
  shoulderDrop?: string;
  handleDrop?: string;
  countryOfOrigin?: string;
}

export interface StoreMediaEntity {
  compactUrl: string;
  deleted: boolean;
  displayOrder: string;
  isContent: boolean;
  isGallery: boolean;
  isQc: boolean;
  largeUrl: string;
  mediumUrl: string;
  thumbUrl: string;
  type: string;
  uuid: string;
  xlargeUrl: string;
  originalUrl?: string;
}

export enum CommissionUserType {
  tvb = 'tvb',
  private = 'private',
  professional = 'professional',
}

export function MapElkCard(data: any): Hit {
  return {
    id: data.id,
    name: data.name,
    brandName: data.brand_name,
    stylesSeoUrl: data.styles_seo_url_en,
    brandsSeoUrl: data.brands_seo_url_en,
    regularPriceUSD: data.regular_price_USD,
    regularPriceEUR: data.regular_price_EUR,
    regularPriceGBP: data.regular_price_GBP,
    regularPriceDKK: data.regular_price_DKK,
    regularPriceSEK: data.regular_price_SEK,
    regularPriceNOK: data.regular_price_NOK,
    regularPricePLN: data.regular_price_PLN,
    regularPriceJPY: data.regular_price_JPY,
    discountedPriceUSD: data.discounted_price_USD,
    discountedPriceEUR: data.discounted_price_EUR,
    discountedPriceGBP: data.discounted_price_GBP,
    discountedPriceDKK: data.discounted_price_DKK,
    discountedPriceSEK: data.discounted_price_SEK,
    discountedPriceNOK: data.discounted_price_NOK,
    discountedPricePLN: data.discounted_price_PLN,
    discountedPriceJPY: data.discounted_price_JPY,
    bagsSize: data.bags_size,
    clothingSize: data.clothing_size,
    shoesSize: data.shoes_size,
    stock: data.stock,
    imageUrl: data.imgix_image_url,
    totalWishlisted: data.total_wishlisted,
    commissionUserId: data.commission_user_id,
    commissionUserType: data.commission_user_type,
    isDiscount: data.is_discount,
    discount: data.discount,
    fixedDiscount: data.fixed_discount,
    discountPercentage: data.discount_percentage,
    sku: data.sku,
    sellerSku: data.seller_sku,
    category: data.category ?? data.parent_category_en?.name,
    sub: data.sub ?? data.category_en?.name,
    color: data.color,
    objectId: data.objectID,
    conditionRating: data.condition_rating,
    discover: data.discover,
  };
}
